import React from "react";
import styled from 'styled-components';
import Slider from "react-slick";
// import imgOne from "../../img/newsEvent.jpg";

import imgOne from "../../img/hp_1.png";
import imgThree from "../../img/hp_3.png";
import imgTwo from "../../img/hp_2.png";
import imgFor from "../../img/hp_4.png";
import imgFive from "../../img/hp_5.png";
import imgSix from "../../img/hp_6.png";


const Scope =styled.div`
text-align: -webkit-center;
`
export default function SimpleSlider() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    autoplay:true,
  };
  
  const images = [
    imgOne,imgTwo,imgThree,imgFor,imgFive
    // imgOne,imgTwo,imgThree,imgFor,imgFive
    // imgThree
    // imgThree,imgFor
    // imgTwo,imgTimgFor
    // imgOne,imgFive,imgTwo,imgThree,imgFor
  ] 
  return (
    <Slider {...settings}>
      {images.map((src: string, index: number)=>
        <Scope >
          {index == 1 &&
            <img style={{width:'80%',height:'auto'}} src={src} key={`${index}`} alt="pictuer" />    
          }          
          {index !== 1 &&
            <img style={{width:'80%',height:'auto'}} src={src} key={`${index}`} alt="pictuer" />    
          }
        </Scope>
      )}
    </Slider>
  );
}
